import styled from "styled-components";

export const Add = styled.div`
  padding-bottom: 20px;
  display: flex;
  justify-content: end;
`;
export const FormWrapper = styled.div`
  padding: 0px 30px 30px 30px;
  .sendBtn {
    margin-top: 23px;
  }
`;
export const WrapModal = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;
`;
export const RowFlex = styled.div`
  display: flex;
  gap: 20px;
  width: 100%;
  flex-wrap: wrap;
  margin-bottom: 20px;
  .card {
    background-color: white;
    min-width: 284px;
    width: 300px;
    max-width: 350px;
    border-radius: 8px;
    max-height: 200px;
    height: 170px;
    min-height: 160px;
  }
`;
